import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { Container } from "react-bootstrap";
import Layout from "@layout";
import Table from "react-bootstrap/Table";
import SEO from "@components/seo";
import PageBreadcrumb from "../components/pagebreadcrumb";
import { normalizedData } from "@utils/functions";
import jsonDataInit from "../data/others/directors-report.json";
import axios from "axios";
import { useEffect, useState } from "react";
import Preload from "../components/preloadPage/preload";
const DirectorsReport = ({ data, location, pageContext }) => {
    const [jsonData, setJsonData] = useState(jsonDataInit);
    const [preload, setPreload] = useState(true);
    useEffect(() => {
        axios(
            "https://admin.reliance.com.bd/api/sendJSON/62a75d0182f44849ffe9c436"
        )
            .then((resultData) => {
                setJsonData(resultData.data);
                setPreload(false);
            })
            .catch((err) => {
                console.log(err);
                setPreload(false);
            });
    }, []);
    const globalContent = normalizedData(data?.allGeneral?.nodes || []);
    return (
        <Layout
            data={{
                ...globalContent["menu"],
                ...globalContent["footer"],
            }}
        >
            {preload && <Preload />}
            <SEO title="Directors report to the shareholders" pathname="/" />
            <PageBreadcrumb
                pageContext={pageContext}
                location={location}
                title="Directors Report"
            />
            <Container style={{ paddingTop: "20px", paddingBottom: "60px" }}>
                {jsonData.map((par, j) => {
                    return (
                        <p key={j} style={{ marginBottom: "0px" }}>
                            <a
                                style={{ color: "#000", fontSize: "20px" }}
                                href={par.link}
                            >
                                {par.title}
                            </a>
                        </p>
                    );
                })}
            </Container>
        </Layout>
    );
};
DirectorsReport.propTypes = {
    location: PropTypes.object,
    pageContext: PropTypes.object,
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allArticle: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export const query = graphql`
    query DirectorsReportQuery {
        allGeneral {
            nodes {
                section
                id
                menu {
                    ...Menu
                }
                footer {
                    ...Footer
                }
            }
        }
        allArticle {
            nodes {
                ...Articles
            }
        }
    }
`;

export default DirectorsReport;
